import { z, ZodType } from 'zod'

import { TripBookingGuidelineInput } from '../../../lib/types/models/trip-booking/trip-booking-guideline-input'
import { TripBookingGuideline } from '../../../lib/types/models/trip-booking/trip-booking-guildeline'
import { createStringSchema } from '../../../lib/utils/validations/string-validation'

export const tripBookingGuidelinesSchema: ZodType<TripBookingGuidelineInput> = z.object({
  label: createStringSchema('Type'),
  description: createStringSchema('Description')
})

export const mapTripBookingGuidelineToInput = (
  tripAddress: TripBookingGuideline
): TripBookingGuidelineInput => {
  return {
    label: tripAddress.label,
    description: tripAddress.description
  }
}
